import React from 'react';
import styles from './Terms.module.css';

const TermsOfService = () => (
  <div className={styles.container}>
    <h1>Terms of Service</h1>
    <p>
        <strong>Effective Date:</strong> July 19, 2025 &nbsp;&nbsp;|&nbsp;&nbsp; <strong>Last Updated:</strong> July 19, 2025
    </p>


    <p>
      Welcome to Loggable. These Terms of Service ("Terms") govern your access to and use of Loggable’s mobile and web applications (collectively, the “Services”), operated by Loggable LLC (“we”, “us”, or “our”).
    </p>
    <p>
      By accessing or using Loggable, you agree to be bound by these Terms. If you do not agree, do not use the Services.
    </p>

    <h2>1. Description of Service</h2>
    <p>
      Loggable assists users in digitizing handwritten logbook entries into structured, downloadable tabular formats. Users can create, manage, and export personal logbooks through our platform.
    </p>

    <h2>2. Account Registration</h2>
    <p>
      To use certain features, you must create an account through AWS Cognito. You agree to provide accurate information and keep it up to date. You are responsible for safeguarding your account credentials.
    </p>

    <h2>3. Fees and Payments</h2>
    <p>
      Loggable offers a free trial and a premium subscription plan processed through Stripe. By purchasing a subscription, you authorize us to charge your payment method for all applicable fees.
    </p>

    <h2>4. User-Generated Content</h2>
    <p>
      You retain ownership of your created logbooks. By using the Services, you grant us a license to store, process, and transmit your content solely to provide the service features.
    </p>
    <p>
      You agree not to upload content that is illegal, offensive, or infringes on others’ rights.
    </p>

    <h2>5. Acceptable Use</h2>
    <ul>
      <li>Use the Services for lawful purposes only</li>
      <li>Do not reverse engineer or interfere with platform functionality</li>
      <li>Do not upload viruses or harmful code</li>
    </ul>

    <h2>6. Third-Party Services</h2>
    <p>
      Loggable integrates with third-party services including AWS, Stripe, and OpenAI. Your use of these services is also subject to their respective terms and privacy policies.
    </p>

    <h2>7. Termination</h2>
    <p>
        We may suspend or terminate your access to Loggable at our sole discretion for any breach of these Terms. You may delete your account at any time. Reach out to{' '}
        <a href="mailto:support@loggable.net">support@loggable.net</a> for assistance.
    </p>

    <h2>8. Disclaimer of Warranties</h2>
    <p>
      Loggable is provided "as is" and "as available." We do not guarantee that the Services will be uninterrupted or error-free.
    </p>

    <h2>9. Limitation of Liability</h2>
    <p>
      To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Services.
    </p>

    <h2>10. Governing Law and Dispute Resolution</h2>
    <p>
      These Terms shall be governed by the laws of Pennsylvania, United States of America, without regard to its conflict of laws principles.
    </p>
    <p>
      Optional: Disputes may be resolved through binding arbitration rather than in court.
    </p>

    <h2>11. Changes to Terms</h2>
    <p>
      We may update these Terms from time to time. We’ll notify you of any material changes by updating the date and possibly through in-app or email notices.
    </p>

    <h2>12. Contact</h2>
    <p>
        If you have questions about these Terms, contact us at{' '}
        <a href="mailto:support@loggable.net">support@loggable.net</a>.
    </p>
  </div>
);

export default TermsOfService;
